<template>

    <div class="container">

        <div class="content">

            <div class="items">

                <template v-if="featured.length > 0">
                
                    <featured-news :news="featured"></featured-news>

                </template>


                <p class="headline other_news">OTHER NEWS</p>

                <div class="other__news">

                    <div class="single_news" v-for="other_news, index in news" v-bind:key="index" @click="toNews(other_news.slug)">
                        
                        <div class="mobile__only__bg" v-bind:style="{
                            background: get_background_image(other_news),
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundColor: 'black',
                            backgroundPosition: 'center 80%'
                            }">
                        </div>

                        <div class="title__shortdesc">
                            <p class="title">{{ other_news.title }}</p>
                            <p class="desc">{{ other_news.short_description }}</p>
                        </div>

                        <p class="date">{{ other_news.created_on_regular }}</p>

                        <a class="read__more" :href="'/news/' + other_news.slug">
                            <p>READ MORE</p>
                            <div class="span_bg"></div>
                        </a>

                        
                    
                    </div>

                </div>


            </div>


        </div>

    </div>

</template>
<script>
    export default {
        data(){
            return {
            }
        },
        props: ['news', 'featured'],
        methods: {
            get_background_image(news){
                return "url('" + '/image/' + news.media_path + '/' + news.featured_image + "')"
            },
            toNews(slug){
                if(window.innerWidth < 837){
                    window.location.href = '/news/' + slug;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

    .content{

        display: flex;
        flex-direction: row;
        width: 100%;
        // max-width: 100%;
        // margin: auto;
        background: linear-gradient(180deg, #2A1542 0%, #000000 100%);

        .items{
            display: flex;
            flex-direction: column;
            // background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
            padding: 75px 112px;
            width: 100%;
            max-width: 1350px;
            margin: auto;

            .headline{
                font-family: 'DIN Next LT Pro Bold';
                font-style: normal;
                // font-weight: 700;
                font-size: 30px;
                line-height: 36px;

                color: #FFFFFF;
                margin: 0;
            }                

            .other__news{
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 100%;
                max-width: 1300px;
                margin: 0 auto;
                margin-top: 94px;


                .single_news{
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    overflow: hidden;

                    border-bottom: 1px solid #ED1163;
                    margin-bottom: 80px;
                    position: relative;

                    .mobile__only__bg{
                        display: none;
                        width: 100%;
                        height: 400px;
                        position: absolute;
                        z-index: 1;

                        &::after {
                            position: absolute;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            background: black;
                            opacity: .7;
                            content: "";
                            z-index: -1;
                        }
                    }

                    .title__shortdesc{
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        max-width: 675px;
                        z-index: 2;

                        .title{
                            font-family: 'DIN Next LT Pro Regular';
                            font-style: normal;
                            // font-weight: 500;
                            font-size: 35px;
                            line-height: 35px;
                            text-transform: uppercase;

                            color: #F9F9F9;
                            margin: 0;
                            margin-bottom: 20px;
                        }

                        .desc{
                            font-family: 'DIN Next LT Pro Ultralight';
                            font-style: normal;
                            // font-weight: 300;
                            font-size: 14px;
                            line-height: 14px;
                            text-transform: lowercase;

                            color: #FFFFFF;

                            margin: 0;
                            height: 50px;
                        }
                    }

                    .date{
                        font-family: 'DIN Next LT Pro Regular';
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 12px;
                        line-height: 12px;
                        /* identical to box height, or 150% */

                        text-transform: uppercase;

                        color: #FFFFFF;
                        margin-top: 0;
                        margin-bottom: auto;
                        z-index: 2;
                        margin-right: 14px;
                    }

                    .read__more{
                        display: block;
                        background: rgba(15, 15, 15, 0.3);
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        width: 409px;
                        height: 50px;
                        margin-top: 0;
                        margin-bottom: auto;
                        // margin-bottom: -9px;
                        cursor: pointer;
                        user-select: none;
                        position: relative;
                        overflow-y: hidden;
                        z-index: 4;
                        text-decoration: none;
                        margin-left: auto;
                        margin-right: 0;
                        border: 1px solid #ED1163;

                        z-index: 2;

                        p{
                            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 20px;
                            line-height: 54px;
                            text-align: center;
                            letter-spacing: 0.2em;
                            text-transform: uppercase;
                            margin: 0 auto;

                            color: #FFFFFF;
                            position: relative;
                            z-index: 4;
                        }

                        div.span_bg{
                            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                            height: 100%;
                            width: 100%;
                            transition: all .3s ease-in-out;
                            margin-top: auto;
                            margin-bottom: 0;
                            opacity: 0;

                            position: absolute;
                            bottom: -50px;
                            z-index: 3;
                        }

                        &:hover{
                            div.span_bg{
                                height: calc(100%);
                                bottom: 0;
                                opacity: 1;
                            }
                        }
                    }

                }


            }
        }

    }


    @media screen and (max-width: 836px) {

        .container{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 100%;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                        }

                        .headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }
        }

        .content{
            .left, .right{
                display: none;
            }

            .items{
                padding: 75px 0;
                width: 100%;

                .headline{
                    padding: 0 24px;
                    text-align: center;
                    font-size: 22px;
                    line-height: 26px;
                }

                .other__news{
                    .single_news{
                        flex-direction: column;
                        border-bottom: none;
                        width: 90%;
                        margin: 0 auto;
                        margin-bottom: 24px;

                        background: #212121;


                        .mobile__only__bg{
                            display: block;
                        }

                        .title__shortdesc{
                            width: 95%;
                            margin: 12px;

                            .title{
                                text-align: center;
                                font-size: 24px;
                                line-height: 24px;
                            }

                            .desc{
                                text-align: center;
                            }
                        }

                        .date{
                            margin-bottom: 12px;
                            margin-left: auto;
                            margin-right: auto;
                        }

                        .read__more{
                            background: rgba(0, 0, 0, 0.6);
                            border: 1px solid #ED1163;
                            height: 31px;
                            margin-left: auto;
                            margin-right: auto;
                            // width: 100%;
                            width: 99%;

                            p{
                                font-size: 12px;
                                line-height: 33px;
                            }
                        }
                    }
                }
            }
        }

    }
        
   


</style>